import { useEffect, useRef, useState } from "react";

export default function useDebouncedOnChange(initialValue, delay = 500) {
  const [value, setValue] = useState(initialValue);
  const timeoutRef = useRef(null);

  const handleChange = (onDebounce) => (e) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      onDebounce(newValue);
    }, delay);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { value, setValue, handleChange };
}
